interface IComment {
  trip: string;
  comment: string;
  name: string;
}
export const COMMENTS: IComment[] = [
  {
    trip: 'Paris - La Rochelle',
    comment: 'reviewTestimonial1',
    name: 'Romain',
  },
  {
    trip: 'Lyon - Bruxelles',
    comment: 'reviewTestimonial2',
    name: 'Mathilde',
  },
  {
    trip: 'Lyon - Tignes',
    comment: 'reviewTestimonial3',
    name: 'Isabelle',
  },
];
